import { __decorate } from "tslib";
import { CommonModule } from '@angular/common';
import { provideRootRoutes } from '@core/frontend-shared';
import { FrontendFeaturePlugin } from '@core/frontend-shared/feature';
import { ClassName } from '@core/shared/class-name';
import * as i0 from "@angular/core";
let PflegethekeBillingFrontendAdminFeature = /*#__PURE__*/(() => {
  let PflegethekeBillingFrontendAdminFeature = class PflegethekeBillingFrontendAdminFeature extends FrontendFeaturePlugin {
    getFeatureContext() {
      return {"package":"@pflegetheke/billing/frontend-admin","featureId":"pflegetheke-billing"};
    }
    getFeatureFunctionality(functionality) {
      functionality.defineMenuItems({
        adminToolbar: [{
          label: 'Abrechnung',
          routerLink: 'billing',
          icon: 'money-check-dollar',
          priority: 7
        }]
      });
    }
    static {
      this.ɵfac = /*@__PURE__*/(() => {
        let ɵPflegethekeBillingFrontendAdminFeature_BaseFactory;
        return function PflegethekeBillingFrontendAdminFeature_Factory(__ngFactoryType__) {
          return (ɵPflegethekeBillingFrontendAdminFeature_BaseFactory || (ɵPflegethekeBillingFrontendAdminFeature_BaseFactory = i0.ɵɵgetInheritedFactory(PflegethekeBillingFrontendAdminFeature)))(__ngFactoryType__ || PflegethekeBillingFrontendAdminFeature);
        };
      })();
    }
    static {
      this.ɵmod = /*@__PURE__*/i0.ɵɵdefineNgModule({
        type: PflegethekeBillingFrontendAdminFeature
      });
    }
    static {
      this.ɵinj = /*@__PURE__*/i0.ɵɵdefineInjector({
        providers: [provideRootRoutes([{
          path: 'billing',
          loadChildren: () => import('./billing-reports/reports.module').then(m => m.BillingReportsModule)
        }])],
        imports: [CommonModule]
      });
    }
  };
  PflegethekeBillingFrontendAdminFeature = __decorate([ClassName("PflegethekeBillingFrontendAdminFeature")], PflegethekeBillingFrontendAdminFeature);
  return PflegethekeBillingFrontendAdminFeature;
})();
export { PflegethekeBillingFrontendAdminFeature };